export enum Area {
    None = 0,
    PlantManager = 1,
    WorkPackManager = 2,
}

export class ActionModel {
    plantManager: PlantManagerActionType;
    workPackManager: WorkPackManagerActionType;
}

export enum PlantManagerActionType {
    None = 0,
    OpenEditTaggedItem = 1,
    OpenDocumentDrawingViewer = 2,
}

export enum WorkPackManagerActionType {
    None = 0,
    OpenEditWorkPack = 1,
    OpenEditActivityRecordExisting = 2,
    OpenEditNextOrSpecificWorkflowStep = 3,
}

export class TypeModel {
    PlantManager: Types;
    WorkPackManager: WorkPackManagerType;
    WorkPackManagerWorkflowStep: WorkPackManagerWorkflowStepType;
}
export enum Types {
    PlantManager = 0,
    WorkPackManager = 1,
    WorkPackManagerWorkflowStep = 2,
}
export enum WorkPackManagerType {
    ActivateDetailsTab = 0,
    ActivateAllocationTab = 1,
    ActivateActivityRecordsTab = 2,
    ActivateDocumentsTab = 3,
}
export enum WorkPackManagerWorkflowStepType {
    OpenEditNextAvailableWorkflowStep = 0,
}
export enum ActivityPackTypeStatusAction {
    None = 0,
    Create = 1,
    View = 2,
    Complete = 3,
    Violation = 4,
    AlreadyCompleted = 5,
    Modify = 6,
}
